import React from 'react'
import img2 from '../../images/img2.jpeg'
import img10 from '../../images/img10.jpeg'
import img4 from '../../images/img4.jpeg'
import img5 from '../../images/img5.jpeg'
import img3 from '../../images/img3.jpeg'
// export default function Card() {
//   return (
//     <div>

        
//   {/* <section className="text-gray-600 body-font overflow-hidden">
//   <div className="container px-5 py-24 mx-auto">
//     <div className="lg:w-4/5 mx-auto flex flex-wrap">
//       <div className="lg:w-1/2 w-full lg:pr-10 lg:py-6 mb-6 lg:mb-0">
//         <h2 className="text-sm title-font text-gray-500 tracking-widest">
//           BRAND NAME
//         </h2>
//         <h1 className="text-gray-900 text-3xl title-font font-medium mb-4">
//           Animated Night Hill Illustrations
//         </h1>
//         <div className="flex mb-4">
//           <a className="flex-grow text-indigo-500 border-b-2 border-indigo-500 py-2 text-lg px-1">
//             Description
//           </a>
//           <a className="flex-grow border-b-2 border-gray-300 py-2 text-lg px-1">
//             Reviews
//           </a>
//           <a className="flex-grow border-b-2 border-gray-300 py-2 text-lg px-1">
//             Details
//           </a>
//         </div>
//         <p className="leading-relaxed mb-4">
//           Fam locavore kickstarter distillery. Mixtape chillwave tumeric
//           sriracha taximy chia microdosing tilde DIY. XOXO fam inxigo juiceramps
//           cornhole raw denim forage brooklyn. Everyday carry +1 seitan poutine
//           tumeric. Gastropub blue bottle austin listicle pour-over, neutra jean.
//         </p>
//         <div className="flex border-t border-gray-200 py-2">
//           <span className="text-gray-500">Color</span>
//           <span className="ml-auto text-gray-900">Blue</span>
//         </div>
//         <div className="flex border-t border-gray-200 py-2">
//           <span className="text-gray-500">Size</span>
//           <span className="ml-auto text-gray-900">Medium</span>
//         </div>
//         <div className="flex border-t border-b mb-6 border-gray-200 py-2">
//           <span className="text-gray-500">Quantity</span>
//           <span className="ml-auto text-gray-900">4</span>
//         </div>
//         <div className="flex">
//           <span className="title-font font-medium text-2xl text-gray-900">
//             $58.00
//           </span>
//           <button className="flex ml-auto text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded">
//             Button
//           </button>
//           <button className="rounded-full w-10 h-10 bg-gray-200 p-0 border-0 inline-flex items-center justify-center text-gray-500 ml-4">
//             <svg
//               fill="currentColor"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               className="w-5 h-5"
//               viewBox="0 0 24 24"
//             >
//               <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
//             </svg>
//           </button>
//         </div>
//       </div>
//       <img
//         alt="ecommerce"
//         className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
//         src="https://dummyimage.com/400x400"
//       />
//     </div>
//   </div>
// </section> */}


//     </div>
//   )
// }

const features = [
    { name: 'Origin', description: 'Designed by Good Goods, Inc.' },
    { name: 'Material', description: 'Solid walnut base with rare earth magnets and powder coated steel card cover' },
    { name: 'Dimensions', description: '6.25" x 3.55" x 1.15"' },
    { name: 'Finish', description: 'Hand sanded and finished with natural oil' },
    { name: 'Includes', description: 'Wood card tray and 3 refill packs' },
    { name: 'Considerations', description: 'Made from natural materials. Grain and color vary with each item.' },
  ]
  
  export default function Card() {
    return (
      <div className="bg-white">
        <div className="mx-auto grid max-w-2xl grid-cols-1 items-center gap-x-8 gap-y-16 px-4 py-24 sm:px-6 sm:py-32 lg:max-w-7xl lg:grid-cols-2 lg:px-8">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Technical Specifications</h2>
            <p className="mt-4 text-gray-500">
              The walnut wood card tray is precision milled to perfectly fit a stack of Focus cards. The powder coated
              steel divider separates active cards from new ones, or can be used to archive important task lists.
            </p>
  
            <dl className="mt-16 grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-2 sm:gap-y-16 lg:gap-x-8">
              {features.map((feature) => (
                <div key={feature.name} className="border-t border-gray-200 pt-4">
                  <dt className="font-medium text-gray-900">{feature.name}</dt>
                  <dd className="mt-2 text-sm text-gray-500">{feature.description}</dd>
                </div>
              ))}
            </dl>
          </div>
          <div className="grid grid-cols-2 grid-rows-1 gap-4 sm:gap-6 lg:gap-8">
            <img
              src={img4}
              alt="Top down view of walnut card tray with embedded magnets and card groove."
              className="transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300  rounded-lg bg-blue-500 shadow-lg shadow-blue-500/50 origin-bottom rotate-50  saturate-0 hover:saturate-50"
            />
            <img
              src={img5}
              alt="Top down view of walnut card tray with embedded magnets and card groove."
              className="transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300  rounded-lg bg-blue-500 shadow-lg shadow-blue-500/50 origin-bottom rotate-50  blur-sm hover:blur-none "
            />
            <img
              src={img10}
              alt="Side of walnut card tray with card groove and recessed card area."
              className="transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300  rounded-lg bg-blue-500 shadow-lg shadow-blue-500/50 origin-bottom rotate-50  blur-sm hover:blur-none "
            />
            <img
              src={img3}
              alt="Walnut card tray filled with cards and card angled in dedicated groove."
              className="transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300  rounded-lg bg-blue-500 shadow-lg shadow-blue-500/50 origin-bottom rotate-50  saturate-0 hover:saturate-50"
            />
          </div>
        </div>







        <div className="bg-white py-6 sm:py-8 lg:py-12">
  <div className="mx-auto max-w-screen-2xl px-4 md:px-8">
    <div className="flex flex-col overflow-hidden rounded-lg bg-gray-900 sm:flex-row md:h-80">
      {/* content - start */}
      <div className="flex w-full flex-col p-4 sm:w-1/2 sm:p-8 lg:w-2/5">
        <h2 className="mb-4 text-xl font-bold text-white md:text-2xl lg:text-4xl">
          Summer Sale
          <br />
          Up to 70% off.
        </h2>
        <p className="mb-8 max-w-md text-gray-400">
          This is a section of some simple filler text, also known as
          placeholder text. It shares some characteristics of a real written
          text.
        </p>
        <div className="mt-auto">
          <a
            href="#"
            className="inline-block rounded-lg bg-white px-8 py-3 text-center text-sm font-semibold text-gray-800 outline-none ring-indigo-300 transition duration-100 hover:bg-gray-100 focus-visible:ring active:bg-gray-200 md:text-base"
          >
            Save now
          </a>
        </div>
      </div>
      {/* content - end */}
      {/* image - start */}
      <div  className="order-first  w-full bg-gray-700 sm:order-none sm:h-auto sm:w-1/2 lg:w-3/5">
        <img
          src={img2}
          loading="lazy"
          alt="Photo by Dom Hill"
          className="h-full w-full  object-center"
        />
      </div>
      {/* image - end */}
    </div>
  </div>
</div>

<br />


      </div>
    )
  }
  